enum BilledStatus {
  Unspecified = 'Unspecified',
  Billed = 'Billed',
  NotBilled = 'NotBilled',
}

export default BilledStatus;
